import { render, staticRenderFns } from "./renderSvg.vue?vue&type=template&id=44186f5c&"
import script from "./renderSvg.vue?vue&type=script&lang=js&"
export * from "./renderSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports